import {
  AccountTreeTwoTone,
  AppRegistrationTwoTone,
  ApprovalTwoTone,
  AssignmentReturn,
  CurrencyRupeeTwoTone,
  DashboardTwoTone,
  DataThresholdingTwoTone,
  DetailsTwoTone,
  EngineeringTwoTone,
  EventRepeatTwoTone,
  ExpandLess,
  ExpandMore,
  LibraryBooks,
  LogoutTwoTone,
  MarkEmailRead,
  MarkEmailReadTwoTone,
  NoteAddTwoTone,
  PolicyTwoTone,
  Preview,
  ReceiptLongTwoTone,
  SaveAs,
  Summarize,
  SupportAgentTwoTone,
  Undo,
  VisibilityTwoTone,
} from "@mui/icons-material";
import SwipeLeftAltIcon from "@mui/icons-material/SwipeLeftAlt";
import LoanClosure from "../LoanClosure/LoanClosure";
import axios from "axios";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import FunctionsIcon from "@mui/icons-material/Functions";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AddModeratorTwoToneIcon from "@mui/icons-material/AddModeratorTwoTone";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import ApprovalIcon from "@mui/icons-material/Approval";
import CreateTwoToneIcon from "@mui/icons-material/CreateTwoTone";
import GetAppIcon from "@mui/icons-material/GetApp";
import ListAltTwoToneIcon from "@mui/icons-material/ListAltTwoTone";
import MenuIcon from "@mui/icons-material/Menu";
import PersonIcon from "@mui/icons-material/Person";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import { Backdrop, CircularProgress, Skeleton } from "@mui/material";
import {
  Chip,
  Collapse,
  Divider,
  ListItemText,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import ScheduleIcon from "@mui/icons-material/Schedule";
import MuiAppBar from "@mui/material/AppBar";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Cookies from "js-cookie";
import { default as React, useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ShortcutDialog from "./ShortcutDialog";
import FilePaymentInt from ".././FilePayment/FilePaymentModes/FilePaymentInt";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import SFLogoSmall from "../../images/SFLogo.png";
import Logo from "../../images/SF_Logo.png";
import AccrualWaiver from "../Accrual/AccrualWaiver";
import AdditionalAccrual from "../Accrual/AdditionalAccrual";
import ChequeReturn from "../ChequeReturn/ChequeReturn";
import GetBranchArray from "../CustomComponents/GetBranchArray";
import { Dashboard } from "../Dashboard/Dashboard";
import DisbursementCreate from "../Disbursement/Disbursement_Detail/Disbursement_Create/DisbursementCreate";
import DisbursementModify from "../Disbursement/Disbursement_Detail/Disbursement_Modify/DisbursementModify";
import DisbursementView from "../Disbursement/Disbursement_Detail/Disbursement_View/DisbursementView";
import DisbursementApprovalList from "../Disbursement/Disbursement_List/DisbursementApprovalList";
import DisbursementCreatePortal from "../Disbursement/Disbursement_List/DisbursementCreatePortal";
import DisbursementRequestList from "../Disbursement/Disbursement_List/DisbursementRequestList";
import FileReceipt from "../File_Receipt/FileReceipt";
import JournalVoucher from "../Jv/JournalVoucher";
import MandateReturn from "../MandateReturn/MandateReturn";
import NachInward from "../Nach/NachInward";
import NachMandate from "../Nach/NachMandate";
import NachRetrieval from "../Nach/NachRetrieval";
import Verification from "../Nach/Verification";
import ParameterMaintenance from "../ParameterMaintenance/ParameterMaintenance";
import Posting from "../Report/Posting";
import Repayment from "../Report/Repayment";
import Retrival from "../Report/Retrival";
import { BranchAction } from "../Store/Branch";
import store from "../Store/index";
import FolderDeleteIcon from "@mui/icons-material/FolderDelete";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import PaidIcon from "@mui/icons-material/Paid";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import { NachFilterReducerAction } from "../Store/NachFilterReducer";
import "./PageLayout.css";
import FilePaymentIntegration from "../FilePayment/FilePaymentIntegration";
import FileReceiptView from "../File_Receipt/FileReceiptView";
import AmortCalculation from "../AmortCalculation/AmortCalculation";
import FilePaymentIntegrationModify from "../FilePayment/FilePaymentModify/FilePaymentIntegrationModify";
import { FilePaymentModeReducerAction } from "../Store/FilePayment/FilePaymentModeReducer";
import FilePaymentDelete from "../FilePayment/FilePaymentDelete";
import FilePaymentView from "../FilePayment/FilePaymentView";
import FilePaymentEdit from "../FilePayment/FilePaymentEdit";
import FilePaymentApproval from "../FilePayment/FilePaymentApproval";
import FilePaymentFIl from "../FilePayment/FilePaymentModes/FilePaymentFIl";
import NachExclude from "../Nach/NachExclude";
import ChequeAndMandateBulkReturn from "../ChequeAndMandateBulkReturn/ChequeAndMandateBulkReturn";
import PageNotFound from "../CustomComponents/PageNotFound";
import { PageNotFoundReducerAction } from "../Store/PageNotFound/PageNotFoundReducer";

import CashHandlingCharge from "../masterscreens/CashHandlingCharge";

import ReportProcess from "../LoanProcessingStatement/ReportProcess";
import SettlementFigureReport from "../SettlementFigureReport/SettlementFigureReport";
import PrePaymentHandling from "../masterscreens/PrePaymentHandling";
import { SpecialAccessDetailAction } from "../Store/SpecialAccess/SpecialAccessDetailReducer";
import NoSpecialAccess from "../CustomComponents/NoSpecialAccess";
import SpecialFunctionAccess from "../masterscreens/SpecialFunctionAccess";
import ListOfValue from "../masterscreens/ListOfValue";
import { loginAction } from "../Store/LoginAuth";
import BatchScheduling from "../BatchScheduling/BatchScheduling";
import RepaymentStructureFilter from "../RepaymentStructure/RepaymentStructureFilter";
import JournalVoucherDetail from "../Jv/JournalVoucherDetail";
import NonPerformingLoan from "../LoanProcessingStatement/NonPerformingLoan";
import SecurityCheque from "../SecurityCheque/SecurityCheque";
import ReSchedulementPage from "../ReSchedulement/ReSchedulementPage";
import NachExtraction from "../Nach/NachExtraction";
import NachActiveDeactive from "../Nach/NachActiveDeactive";
import CovFilter from "../COV/CovFilter";
import CovLoanDetailsDashboard from "../COV/CovLoanDetailsDashboard";
import FeeRateDefinition from "../masterscreens/FeeRateDefinition";
import CovMainDashboard from "../COV/CovMainDashboard";
import CovLosDashboard from "../COV/CovLosDashboard";
import LosMaster from "../LosMaster/LosMaster";
import TextEditor from "../DynamicReport/TextEditor";
import CompanyMaster from "../CompanyMaster/CompanyMaster";
import TriggerView from "../DynamicReport/TriggerView";
import FeeDefinition from "../masterscreens/FeeDefinition";
import CustomerInfo from "../losdata/customerInfo/CustomerInfo";
import LeadInfoList from "../losdata/leadInfo/LeadInfoList";
import LeadInfo from "../losdata/leadInfo/LeadInfo";
import CustomerInfoList from "../losdata/customerInfo/CustomerInfoList";
import ApplicantList from "../losdata/applicantDetails/ApplicantList";
import ApplicantDetails from "../losdata/applicantDetails/ApplicantDetails";

const drawerWidth = 300;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export default function Pagelayout() {
  const [userName, setUserName] = useState("");
  const branchDetails = useSelector((state) => state.branch.header);
  const initialLoad = useSelector((state) => state.branch.initialLoad);
  // total branches data from the branch api to render other parts of screen when branch data loaded from api.
  const branches = store.getState().branch.branches;

  const specialAccessHeaderMap = useSelector(
    (state) => state.specialAccess.specialAccessHeaderMap
  );

  const specialAccessValue = useSelector(
    (state) => state.specialAccess.specialAccessValue
  );
  const modeAccessMap = useSelector(
    (state) => state.specialAccess.modeAccessMap
  );
  const viewValue = modeAccessMap && modeAccessMap.disbursementView;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { search } = useLocation();

  useEffect(() => {
    const users = store.getState().branch.userName;
    if (initialLoad) {
      const [branchName] = GetBranchArray();
      dispatch(BranchAction.updateInitialHeaderBranchDetails(branchName));
    }
    setUserName(users);
  }, [branchDetails, initialLoad]);

  useLayoutEffect(() => {
    const users = store.getState().branch.userName;
    const getUserBranches = async () => {
      const userBranches = await axios.post("/api/getBranchCluster", {
        apiCode: "BRANCH_CLUSTER_API",
        createdBy: users,
        requestBody: {
          username: btoa(users),
        },
      });

      if (userBranches.data.message === "Success") {
        dispatch(BranchAction.updateBranch(userBranches.data.branch_details));
        setTimeout(() => {
          const [branchName] = GetBranchArray();
          dispatch(BranchAction.updateInitialHeaderBranchDetails(branchName));
          setLoading(false);
        }, 500);
      } else {
        setTimeout(() => {
          setLoading(false);
          console.log(userBranches.data.error_msg);
          //setErrorMessage(userBranches.data.error_msg);
          //openAlertHandler();
        }, 1000);
      }
    };
    getUserBranches();
  }, []);
  const users = store.getState().branch.userName;
  dispatch(SpecialAccessDetailAction.setUserDetails(users));
  dispatch(SpecialAccessDetailAction.setModuleDetails());
  const keyList = useSelector((state) => state.specialAccess.keyList);
  const programId = useSelector((state) => state.specialAccess.programId);
  const [expanded, setExpanded] = useState(false);
  const [openDisbursementSubMenu, setOpenDisbursementSubMenu] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openAccrualSubMenu, setOpenAccrualSubMenu] = useState(false);
  const [openMasterSubMenu, setOpenMasterSubMenu] = useState(false);
  const [openDemoSubmenu, setOpenDemoSubMenu] = useState(false);
  const [openNachSubMenu, setOpenNachSubMenu] = useState(false);
  const [openLOSDataSubMenu, setOpenLOSDataSubMenu] = useState(false);
  const [openFileReceiptSubMenu, setOpenFileReceiptSubMenu] = useState(false);
  const [openJVSubMenu, setOpenJVSubMenu] = useState(false);
  const [openFilePaymentSubMenu, setOpenFilePaymentSubMenu] = useState(false);
  const [openReturnProcessSubMenu, setOpenReturnProcessSubMenu] =
    useState(false);
  const [openReportsSubMenu, setOpenReportsSubMenu] = useState(false);
  const [openLetterGenerationSubMenu, setOpenLetterGenerationSubMenu] =
    useState(false);
  const [openPDCSubMenu, setOpenPDCSubMenu] = useState(false);
  const open = Boolean(anchorEl);
  const [loading, setLoading] = useState(true);

  const handleDrawerOpen = (event) => {
    setExpanded(true);
  };

  const handleDrawerClose = (event) => {
    setExpanded(false);
    visibleAnchorElement();
  };
  const visibleAnchorElement = () => {};
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDisbursementMenuClick = () => {
    setOpenDisbursementSubMenu(!openDisbursementSubMenu);
    setOpenAccrualSubMenu(false);
    setOpenDemoSubMenu(false);
    setOpenNachSubMenu(false);
    setOpenFileReceiptSubMenu(false);
    setOpenJVSubMenu(false);
    setOpenReturnProcessSubMenu(false);
    setOpenReportsSubMenu(false);
    setOpenMasterSubMenu(false);
    setOpenPDCSubMenu(false);
    setOpenLetterGenerationSubMenu(false);
    setOpenLOSDataSubMenu(false);
  };

  const handleAccrualSubMenu = () => {
    setOpenDisbursementSubMenu(false);
    setOpenAccrualSubMenu(!openAccrualSubMenu);
    setOpenDemoSubMenu(false);
    setOpenNachSubMenu(false);
    setOpenFileReceiptSubMenu(false);
    setOpenJVSubMenu(false);
    setOpenReturnProcessSubMenu(false);
    setOpenReportsSubMenu(false);
    setOpenMasterSubMenu(false);
    setOpenPDCSubMenu(false);
    setOpenLetterGenerationSubMenu(false);
    setOpenLOSDataSubMenu(false);
  };

  const handlerNachSubMenu = () => {
    setOpenDisbursementSubMenu(false);
    setOpenAccrualSubMenu(false);
    setOpenDemoSubMenu(false);
    setOpenNachSubMenu(!openNachSubMenu);
    setOpenFileReceiptSubMenu(false);
    setOpenJVSubMenu(false);
    setOpenReturnProcessSubMenu(false);
    setOpenReportsSubMenu(false);
    setOpenMasterSubMenu(false);
    setOpenPDCSubMenu(false);
    setOpenLetterGenerationSubMenu(false);
    setOpenLOSDataSubMenu(false);
  };

  const handlerLOSDataSubMenu = () => {
    setOpenDisbursementSubMenu(false);
    setOpenAccrualSubMenu(false);
    setOpenDemoSubMenu(false);
    setOpenNachSubMenu(false);
    setOpenLOSDataSubMenu(!openLOSDataSubMenu);
    setOpenFileReceiptSubMenu(false);
    setOpenJVSubMenu(false);
    setOpenReturnProcessSubMenu(false);
    setOpenReportsSubMenu(false);
    setOpenMasterSubMenu(false);
    setOpenPDCSubMenu(false);
    setOpenLetterGenerationSubMenu(false);
  };

  const handleFilePaymentSubMenu = () => {
    setOpenDisbursementSubMenu(false);
    setOpenAccrualSubMenu(false);
    setOpenDemoSubMenu(false);
    setOpenNachSubMenu(false);
    setOpenFileReceiptSubMenu(false);
    setOpenJVSubMenu(false);
    setOpenFilePaymentSubMenu(!openFilePaymentSubMenu);
    setOpenReturnProcessSubMenu(false);
    setOpenReportsSubMenu(false);
    setOpenMasterSubMenu(false);
    setOpenPDCSubMenu(false);
    setOpenLetterGenerationSubMenu(false);
    setOpenLOSDataSubMenu(false);
  };

  const handlerFileReceiptSubMenu = () => {
    setOpenDisbursementSubMenu(false);
    setOpenAccrualSubMenu(false);
    setOpenDemoSubMenu(false);
    setOpenNachSubMenu(false);
    setOpenFileReceiptSubMenu(!openFileReceiptSubMenu);
    setOpenJVSubMenu(false);
    setOpenFilePaymentSubMenu(false);
    setOpenReturnProcessSubMenu(false);
    setOpenReportsSubMenu(false);
    setOpenMasterSubMenu(false);
    setOpenPDCSubMenu(false);
    setOpenLetterGenerationSubMenu(false);
    setOpenLOSDataSubMenu(false);
  };

  const handlerReturnProcessSubMenu = () => {
    setOpenDisbursementSubMenu(false);
    setOpenAccrualSubMenu(false);
    setOpenDemoSubMenu(false);
    setOpenNachSubMenu(false);
    setOpenFileReceiptSubMenu(false);
    setOpenJVSubMenu(false);
    setOpenFilePaymentSubMenu(false);
    setOpenReturnProcessSubMenu(!openReturnProcessSubMenu);
    setOpenReportsSubMenu(false);
    setOpenMasterSubMenu(false);
    setOpenPDCSubMenu(false);
    setOpenLetterGenerationSubMenu(false);
    setOpenLOSDataSubMenu(false);
  };

  const handlerPDCSubMenu = () => {
    setOpenDisbursementSubMenu(false);
    setOpenAccrualSubMenu(false);
    setOpenDemoSubMenu(false);
    setOpenNachSubMenu(false);
    setOpenFileReceiptSubMenu(false);
    setOpenJVSubMenu(false);
    setOpenFilePaymentSubMenu(false);
    setOpenReturnProcessSubMenu(false);
    setOpenReportsSubMenu(false);
    setOpenMasterSubMenu(false);
    setOpenPDCSubMenu(!openPDCSubMenu);
    setOpenLetterGenerationSubMenu(false);
    setOpenLOSDataSubMenu(false);
  };

  const handlerReportsSubMenu = () => {
    setOpenDisbursementSubMenu(false);
    setOpenAccrualSubMenu(false);
    setOpenDemoSubMenu(false);
    setOpenNachSubMenu(false);
    setOpenFileReceiptSubMenu(false);
    setOpenJVSubMenu(false);
    setOpenFilePaymentSubMenu(false);
    setOpenReturnProcessSubMenu(false);
    setOpenReportsSubMenu(!openReportsSubMenu);
    setOpenMasterSubMenu(false);
    setOpenPDCSubMenu(false);
    setOpenLetterGenerationSubMenu(false);
    setOpenLOSDataSubMenu(false);
  };

  const handlerJVSubMenu = () => {
    setOpenDisbursementSubMenu(false);
    setOpenAccrualSubMenu(false);
    setOpenDemoSubMenu(false);
    setOpenNachSubMenu(false);
    setOpenFileReceiptSubMenu(false);
    setOpenJVSubMenu(!openJVSubMenu);
    setOpenReturnProcessSubMenu(false);
    setOpenReportsSubMenu(false);
    setOpenMasterSubMenu(false);
    setOpenPDCSubMenu(false);
    setOpenLetterGenerationSubMenu(false);
    setOpenLOSDataSubMenu(false);
  };
  const handleMasterSubMenu = () => {
    setOpenDisbursementSubMenu(false);
    setOpenAccrualSubMenu(false);
    setOpenMasterSubMenu(!openMasterSubMenu);
    setOpenDemoSubMenu(false);
    setOpenNachSubMenu(false);
    setOpenFileReceiptSubMenu(false);
    setOpenJVSubMenu(false);
    setOpenReturnProcessSubMenu(false);
    setOpenReportsSubMenu(false);
    setOpenPDCSubMenu(false);
    setOpenLetterGenerationSubMenu(false);
    setOpenLOSDataSubMenu(false);
  };

  const handleLetterGenerationSubMenu = () => {
    setOpenDisbursementSubMenu(false);
    setOpenAccrualSubMenu(false);
    setOpenMasterSubMenu(false);
    setOpenDemoSubMenu(false);
    setOpenNachSubMenu(false);
    setOpenFileReceiptSubMenu(false);
    setOpenJVSubMenu(false);
    setOpenReturnProcessSubMenu(false);
    setOpenReportsSubMenu(false);
    setOpenPDCSubMenu(false);
    setOpenLetterGenerationSubMenu(!openLetterGenerationSubMenu);
    setOpenLOSDataSubMenu(false);
  };
  const handleLogout = () => {
    // Cookies.remove("islogin");
    // dispatch(BranchAction.updateLoginStatus(false));
    sessionStorage.removeItem("ConfigDt");
    sessionStorage.removeItem("randomKey");
    dispatch(BranchAction.updateBranch([]));
    dispatch(BranchAction.updateUserName(""));
    dispatch(BranchAction.resetHeaderValues());
    navigate("/stlap/login", { replace: true });
    dispatch(loginAction.updateLogin(false));
    dispatch(loginAction.updateEmployeeIDScreen(true));
    dispatch(loginAction.updateMobileScreen(false));
    Cookies.remove("Token");
  };

  const menuClickHandler = async (event) => {
    setExpanded(false);
    const targetId = event.currentTarget.id;
    if (
      targetId === "letterGeneration" ||
      targetId === "letterGenerationTrigger"
    ) {
      await getLetterGenerationServerBaseUrl(targetId);
    } else {
      // other pages side menu click.
      routeBasedOnKey(event.currentTarget.id);
    }
  };

  const getLetterGenerationServerBaseUrl = async (targetId) => {
    /* let newAxiosBase = { ...axios };
      newAxiosBase.defaults.baseURL =
        process.env.REACT_APP_NON_LMS_COMMON_LOGIN_BACKEND_SERVER;
          const response = await newAxiosBase.post(
            "nonlmscommonlogin/getSubProductDataByCode",
            {
              subProductCode: ["LETTER_GENERATION"],
            }
          );
          if (response.status === 200) {
            const subProductDetails = response.data;
            const subproducturl = subProductDetails[0]?.subProductCodeUrl;
            const letterGenerationBaseUrl = subproducturl.split("/home")[0];
            let path = letterGenerationBaseUrl + (targetId === "letterGeneration" ? 
            "/stlap_redirect/letterGenerationCreate" : "/stlap_redirect/letterGenerationTrigger");
            window.open(path);
          } else {
            // means can't get the url throw UI error.
            throw new Error("Url to Navigate doesn't found");
          } */
    const response = await axios.post("pageLayout/getLetterUrl", {
      serverType: "LETTER",
    });
    if (response.status === 200) {
      const serVerUrl = response.data;
      let path =
        serVerUrl +
        (targetId === "letterGeneration"
          ? "/letterGenerationCreate"
          : "/letterGenerationTrigger");
      window.open(path);
    } else {
      // means can't get the url throw UI error.
      throw new Error("Url to Navigate doesn't found");
    }
  };

  useEffect(() => {
    getHeaderAccessData();
    getParameterValues();
  }, []);
  const getParameterValues = async () => {
    const response = await axios.get("/parameter/getAllParameterData");
    const dataMap = {};
    response.data.map((parameter) => {
      dataMap[parameter.paramName] = parameter;
    });

    dispatch(SpecialAccessDetailAction.setParameterData(dataMap));
  };
  const getHeaderAccessData = async (data) => {
    const userIdValue = store.getState().branch.userID;
    const response = await axios.get("/specialAccess/getHeaderSpecialAccess", {
      method: "get",
      params: {
        userId: userIdValue,
      },
    });
    let responseData = response.data;
    dispatch(
      SpecialAccessDetailAction.getHeaderData({ response: responseData })
    );
  };
  const [keyName, setKeyName] = useState("");
  useEffect(() => {
    getDirectPathAccess();
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [keyName, specialAccessHeaderMap, modeAccessMap]);
  const getDirectPathAccess = () => {
    const pathName = window.location.pathname.split("/")[3];
    let pageNotFoundValue = "pageNotFound";
    if (pathName) {
      switch (pathName) {
        case "dashboard":
          setKeyName(pathName);
          break;
        case "parameter":
          setKeyName(
            specialAccessHeaderMap.parameter ? pathName : pageNotFoundValue
          );
          break;
        case "additionalAccrual":
          setKeyName(
            specialAccessHeaderMap.additionalAccrual
              ? pathName
              : pageNotFoundValue
          );
          break;
        case "additionalWaiver":
          setKeyName(
            specialAccessHeaderMap.additionalWaiver
              ? pathName
              : pageNotFoundValue
          );
          break;
        case "disbursementCreatePortal":
          setKeyName(
            specialAccessHeaderMap.disbursementCreate
              ? pathName
              : pageNotFoundValue
          );
          break;

        case "disbursementList":
          setKeyName(
            specialAccessHeaderMap.disbursementList
              ? pathName
              : pageNotFoundValue
          );
          break;
        case "disbursementApprovalList":
          setKeyName(
            specialAccessHeaderMap.disbursementApprovalList
              ? pathName
              : pageNotFoundValue
          );
          break;
        case "nachMandate":
          setKeyName(
            specialAccessHeaderMap.nachMandate ? pathName : pageNotFoundValue
          );
          break;
        case "nachRetrieval":
          setKeyName(
            specialAccessHeaderMap.nachRetrieval ? pathName : pageNotFoundValue
          );
          break;
        case "nachInward":
          setKeyName(
            specialAccessHeaderMap.nachInward ? pathName : pageNotFoundValue
          );
          break;
        case "nachExclude":
          setKeyName(
            specialAccessHeaderMap.nachExclude ? pathName : pageNotFoundValue
          );
          break;
        case "verification":
          setKeyName(
            specialAccessHeaderMap.nachVerification
              ? pathName
              : pageNotFoundValue
          );
          break;

        case "approval":
          setKeyName(
            specialAccessHeaderMap.nachActivation ||
              specialAccessHeaderMap.nachDeactivation
              ? pathName
              : pageNotFoundValue
          );
          break;

        case "posting":
          setKeyName(
            specialAccessHeaderMap.nachPosting ? pathName : pageNotFoundValue
          );
          break;
        case "nachExtraction":
          setKeyName(
            specialAccessHeaderMap.nachExtraction ? pathName : pageNotFoundValue
          );
          break;

        case "retrival":
          setKeyName(
            specialAccessHeaderMap.retrival ? pathName : pageNotFoundValue
          );
          break;
        case "chequeReturn":
          setKeyName(
            specialAccessHeaderMap.chequeReturn ? pathName : pageNotFoundValue
          );
          break;
        case "mandateReturn":
          setKeyName(
            specialAccessHeaderMap.mandateReturn ? pathName : pageNotFoundValue
          );
          break;
        case "bulkReturn":
          setKeyName(
            specialAccessHeaderMap.bulkReturn ? pathName : pageNotFoundValue
          );
          break;
        case "bulkChequeAndMandateReturn":
          setKeyName(
            specialAccessHeaderMap.bulkReturn ? pathName : pageNotFoundValue
          );
          break;
        case "jvCreate":
          setKeyName(
            specialAccessHeaderMap.journalVoucherCreate
              ? pathName
              : pageNotFoundValue
          );
          break;
        case "jvDetail":
          setKeyName(
            specialAccessHeaderMap.journalVoucherApprove ||
              specialAccessHeaderMap.journalVoucherDelete ||
              specialAccessHeaderMap.journalVoucherModify ||
              specialAccessHeaderMap.journalVoucherView
              ? pathName
              : pageNotFoundValue
          );
          break;
        case "fileReceiptCreate":
          setKeyName(
            specialAccessHeaderMap.fileReceiptCreate
              ? pathName
              : pageNotFoundValue
          );
          break;
        case "fileReceipt":
          setKeyName(
            specialAccessHeaderMap.fileReceiptView ||
              specialAccessHeaderMap.fileReceiptModify
              ? pathName
              : pageNotFoundValue
          );
          break;

        case "cashHandlingCharge":
          setKeyName(
            specialAccessHeaderMap.cashHandlingCharge
              ? pathName
              : pageNotFoundValue
          );
          break;

        case "specialFunctionAccess":
          setKeyName(
            specialAccessHeaderMap.specialFunctionAccess
              ? pathName
              : pageNotFoundValue
          );
          break;
        case "lov":
          setKeyName(
            specialAccessHeaderMap.listOfValue ? pathName : pageNotFoundValue
          );
          break;
        case "amortCalculation":
          setKeyName(
            specialAccessHeaderMap.amortCalculation
              ? pathName
              : pageNotFoundValue
          );
          break;
        case "reportProcess":
          setKeyName(
            specialAccessHeaderMap.reportProcess ? pathName : pageNotFoundValue
          );
          break;
        case "settlementFigureReport":
          setKeyName(
            specialAccessHeaderMap.settlementFigureReport
              ? pathName
              : pageNotFoundValue
          );
          break;
        case "prePaymentHandling":
          setKeyName(
            specialAccessHeaderMap.prePaymentHandling
              ? pathName
              : pageNotFoundValue
          );
          break;
        case "disbursement":
          let subPath = window.location.pathname.split("/")[4];
          if (subPath === "repaymentStructure") {
            setKeyName(
              specialAccessHeaderMap.repaymentStructure
                ? pathName
                : pageNotFoundValue
            );
          }
          break;
        case "loanClosure":
          setKeyName(
            specialAccessHeaderMap.loanClosure ? pathName : pageNotFoundValue
          );
          break;
        case "reSchedulement":
          setKeyName(
            specialAccessHeaderMap.reSchedulement ? pathName : pageNotFoundValue
          );
          break;
        case "cov":
          setKeyName(
            specialAccessHeaderMap.customerOneView
              ? pathName
              : pageNotFoundValue
          );
          break;
        case "securityChequeCreate":
          setKeyName(
            specialAccessHeaderMap.securityChequeCreate
              ? pathName
              : pageNotFoundValue
          );
          break;
        case "securityCheque":
          setKeyName(
            specialAccessHeaderMap.securityChequeModify
              ? pathName
              : pageNotFoundValue
          );
          break;
        case "batchScheduling":
          setKeyName(
            specialAccessHeaderMap.batch ? pathName : pageNotFoundValue
          );
          break;
      }
    }
  };

  const routeBasedOnKey = (key) => {
    dispatch(PageNotFoundReducerAction.updateActivationState(false));
    setKeyName(key);
    var path = "/stlap/home/dashboard";
    switch (key) {
      case "dashboard":
        path = "/stlap/home/dashboard";
        break;
      case "parameter":
        path = "/stlap/home/parameter";
        break;
      case "additionalAccrual":
        path = "/stlap/home/additionalAccrual";
        break;
      case "additionalWaiver":
        path = "/stlap/home/additionalWaiver";
        break;
      case "disbursementCreatePortal":
        path = "/stlap/home/disbursementCreatePortal";
        break;
      case "disbursementList":
        path = "/stlap/home/disbursementList";
        break;
      case "disbursementApprovalList":
        path = "/stlap/home/disbursementApprovalList";
        break;
      case "filePayment":
        path = "/stlap/home/filePayment";
        break;
      case "filePaymentCreate":
        path = "/stlap/home/filePaymentCreate";
        break;
      case "loanClosure":
        path = "/stlap/home/loanClosure";
        break;
      case "cov":
        path = "/stlap/home/cov";
        break;
      case "filePaymentApproval":
        path = "/stlap/home/filePaymentApproval";
        break;
      case "lov":
        path = "/stlap/home/lov";
        break;
      case "losMaster":
        path = "/stlap/home/losMaster";
        break;
      case "feeDefinition":
        path = "/stlap/home/feeDefinition";
        break;
      case "nachMandate":
        path = "/stlap/home/nachMandate";
        // reset the page & load.
        dispatch(NachFilterReducerAction.resetValues());
        dispatch(NachFilterReducerAction.resetFilterValues());
        dispatch(NachFilterReducerAction.updateApplicationTouchHandler(false));
        dispatch(NachFilterReducerAction.updateBranchTouchHandler(false));
        dispatch(
          NachFilterReducerAction.updateBankAccountNumTouchHandler(false)
        );
        dispatch(NachFilterReducerAction.updateShowMandate(false));
        break;
      case "nachRetrieval":
        path = "/stlap/home/nachRetrieval";
        break;
      case "nachInward":
        path = "/stlap/home/nachInward";
        break;
      case "nachExclude":
        path = "/stlap/home/nachExclude";
        break;
      case "verification":
        path = "/stlap/home/verification";
        break;
      case "approval":
        path = "/stlap/home/approval";
        break;

      case "posting":
        path = "/stlap/home/posting";
        break;
      case "nachExtraction":
        path = "/stlap/home/nachExtraction";
        break;
      case "repayment":
        path = "/stlap/home/repayment";
        break;
      case "retrival":
        path = "/stlap/home/retrival";
        break;
      case "chequeReturn":
        path = "/stlap/home/chequeReturn";
        break;
      case "mandateReturn":
        path = "/stlap/home/mandateReturn";
        break;
      case "bulkChequeAndMandateReturn":
        path = "/stlap/home/bulkReturn";
        break;
      case "jvCreate":
        path = "/stlap/home/jvCreate";
        break;
      case "feeRateDefinition":
        path = "/stlap/home/feeRateDefinition";
        break;
      case "jvDetail":
        path = "/stlap/home/jvDetail";
        break;
      // case "companyMaster":
      //   path = "/stlap/home/companyMaster";
      //   break;
      case "fileReceiptCreate":
        path = "/stlap/home/fileReceiptCreate";
        break;
      case "fileReceiptView":
        path = "/stlap/home/fileReceipt";
        setKeyName("fileReceiptView");
        break;
      case "amortCalculation":
        path = "/stlap/home/amortCalculation";
        break;
      case "cashHandlingCharge":
        path = "/stlap/home/cashHandlingCharge";
        break;

      case "reportProcess":
        path = "/stlap/home/reportProcess";
        break;
      case "settlementFigureReport":
        path = "/stlap/home/settlementFigureReport";
        break;
      case "repaymentStructure":
        path = "/stlap/home/disbursement/repaymentStructure";
        break;
      case "prePaymentHandling":
        path = "/stlap/home/prePaymentHandling";
        break;
      case "specialFunctionAccess":
        path = "/stlap/home/specialFunctionAccess";
        break;
      case "batchScheduling":
        path = "/stlap/home/batchScheduling";
        break;
      case "securityChequeCreate":
        path = "/stlap/home/securityChequeCreate";
        break;
      case "securityCheque":
        path = "/stlap/home/securityCheque";
        break;
      case "filePayment":
        path = "/stlap/home/filePayment";
        break;
      case "reSchedulement":
        path = "/stlap/home/reSchedulement";
        break;
      // case "letterGeneration":
      //   path = letterGenerationBaseUrl + "/stlap_redirect/letterGenerationCreate";
      //   break;
      // case "letterGenerationTrigger":
      //   path = letterGenerationBaseUrl + "/stlap_redirect/letterGenerationTrigger";
      //   break;
      case "leadInformation":
        path = "/stlap/home/losData/leadInfoList";
        break;
      case "customerInformation":
        path = "/stlap/home/losData/customerInfoList";
        break;
      case "applicantDetails":
        path = "/stlap/home/losData/applicantInfoList";
        break;
      default:
        path = "/stlap/home/dashboard";
        break;
    }

    navigate(path, { replace: true });
  };

  const list = (
    <Box
      sx={{
        width: 300,
        display: "block",
        height: "100%",
        backgroundColor: "#169BD5",
        color: "white",
      }}
      role="presentation"
    >
      <List
        sx={{ width: 300, backgroundColor: "#169BD5" }}
        component="nav"
        aria-labelledby="nested-list-subheader"
      >
        {/* Dashboard */}
        <ListItemButton id="dashboard" onClick={menuClickHandler}>
          <ListItemIcon>
            {/* <img  id = 'layout-menu-image' src = {disbusmentImage}/> */}
            <Tooltip title="Dashbard" disableHoverListener={!expanded}>
              <DashboardTwoTone fontSize="medium" sx={{ color: "white" }} />
            </Tooltip>
          </ListItemIcon>
          <ListItemText primary="Dashboard" sx={{ display: "block" }} />
        </ListItemButton>

        {/* Batch Scheduling */}
        {specialAccessHeaderMap.batch && (
          <ListItemButton id="batchScheduling" onClick={menuClickHandler}>
            <ListItemIcon>
              {/* <img  id = 'layout-menu-image' src = {disbusmentImage}/> */}
              <Tooltip title="Batch" disableHoverListener={!expanded}>
                <ScheduleIcon fontSize="medium" sx={{ color: "white" }} />
              </Tooltip>
            </ListItemIcon>
            <ListItemText primary="Batch" sx={{ display: "block" }} />
          </ListItemButton>
        )}

        {/* Parameter Maintenance */}
        {specialAccessHeaderMap.parameter && (
          <ListItemButton id="parameter" onClick={menuClickHandler}>
            <ListItemIcon>
              <Tooltip
                title="Parameter Maintenance"
                disableHoverListener={!expanded}
              >
                <EngineeringTwoTone fontSize="medium" sx={{ color: "white" }} />
              </Tooltip>
            </ListItemIcon>
            <ListItemText
              primary="Parameter Maintenance"
              sx={{ display: "block" }}
            />
          </ListItemButton>
        )}

        {/* Accrual */}
        {specialAccessHeaderMap.additionalFee && (
          <ListItemButton id="fee" onClick={handleAccrualSubMenu}>
            <ListItemIcon>
              <Tooltip title="Additional Fee" disableHoverListener={!expanded}>
                <CurrencyRupeeTwoTone
                  fontSize="medium"
                  sx={{ color: "white" }}
                />
              </Tooltip>
            </ListItemIcon>
            <ListItemText
              id="menu-lable"
              primary="Additional Fee"
              sx={{ display: "block" }}
            />
            {openAccrualSubMenu ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        )}
        <Collapse in={openAccrualSubMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {specialAccessHeaderMap.additionalAccrual && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="additionalAccrual"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  {/* <img id='layout-menu-image' src={Insurance} /> */}
                  <Tooltip title="Accrual" disableHoverListener={!expanded}>
                    <AccountTreeTwoTone
                      fontSize="medium"
                      sx={{ color: "white" }}
                    />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Accrual"
                />
              </ListItemButton>
            )}
            {specialAccessHeaderMap.additionalWaiver && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="additionalWaiver"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip title="Waiver" disableHoverListener={!expanded}>
                    <AddModeratorTwoToneIcon
                      fontSize="medium"
                      sx={{ color: "white" }}
                    />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Waiver"
                />
              </ListItemButton>
            )}
          </List>
        </Collapse>

        {/* Disbursement */}
        {specialAccessHeaderMap.disbursement && (
          <ListItemButton
            id="disbursement"
            onClick={handleDisbursementMenuClick}
          >
            <ListItemIcon>
              {/* <img  id = 'layout-menu-image' src = {disbusmentImage}/> */}
              <Tooltip title="Disbursement" disableHoverListener={!expanded}>
                <CurrencyRupeeTwoTone
                  fontSize="medium"
                  sx={{ color: "white" }}
                />
              </Tooltip>
            </ListItemIcon>
            <ListItemText
              id="menu-lable"
              primary="Disbursement"
              sx={{ display: "block" }}
            />
            {openDisbursementSubMenu ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        )}
        <Collapse in={openDisbursementSubMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {specialAccessHeaderMap.disbursementCreate && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="disbursementCreatePortal"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  {/* <img id='layout-menu-image' src={Insurance} /> */}
                  <Tooltip
                    title="Disbursement Request Create"
                    disableHoverListener={!expanded}
                  >
                    <CreateTwoToneIcon
                      fontSize="medium"
                      sx={{ color: "white" }}
                    />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Disbursement Request Create"
                />
              </ListItemButton>
            )}
            {specialAccessHeaderMap.disbursementList && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="disbursementList"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip
                    title="Disbursement List"
                    disableHoverListener={!expanded}
                  >
                    <ListAltTwoToneIcon
                      fontSize="medium"
                      sx={{ color: "white" }}
                    />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Disbursement List"
                />
              </ListItemButton>
            )}
            {specialAccessHeaderMap.disbursementApprovalList && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="disbursementApprovalList"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip
                    title="Disbursement Approval List"
                    disableHoverListener={!expanded}
                  >
                    <ApprovalTwoTone
                      fontSize="medium"
                      sx={{ color: "white" }}
                    />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Disbursement Approval List"
                />
              </ListItemButton>
            )}
          </List>
        </Collapse>

        {/* Nach */}
        {specialAccessHeaderMap.nach && (
          <ListItemButton id="fee" onClick={handlerNachSubMenu}>
            <ListItemIcon>
              <Tooltip title="NACH" disableHoverListener={!expanded}>
                <AppRegistrationTwoTone
                  fontSize="medium"
                  sx={{ color: "white" }}
                />
              </Tooltip>
            </ListItemIcon>
            <ListItemText
              id="menu-lable"
              primary="NACH"
              sx={{ display: "block" }}
            />
            {openNachSubMenu ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        )}

        <Collapse in={openNachSubMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {specialAccessHeaderMap.nachMandate && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="nachMandate"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip
                    title="Create Mandate"
                    disableHoverListener={!expanded}
                  >
                    <AppRegistrationIcon
                      fontSize="medium"
                      sx={{ color: "white" }}
                    />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Create Mandate"
                />
              </ListItemButton>
            )}
            {specialAccessHeaderMap.nachInward && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="nachInward"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip title="Inward" disableHoverListener={!expanded}>
                    <UploadFileIcon fontSize="medium" sx={{ color: "white" }} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Inward"
                />
              </ListItemButton>
            )}
            {specialAccessHeaderMap.nachVerification && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="verification"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip
                    title="Verification"
                    disableHoverListener={!expanded}
                  >
                    <VerifiedUserIcon
                      fontSize="medium"
                      sx={{ color: "white" }}
                    />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Verification"
                />
              </ListItemButton>
            )}
            {specialAccessHeaderMap.nachExtraction && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="nachExtraction"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip
                    title="Mandate Registration"
                    disableHoverListener={!expanded}
                  >
                    <ApprovalIcon fontSize="medium" sx={{ color: "white" }} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Mandate Registration"
                />
              </ListItemButton>
            )}
            {(specialAccessHeaderMap.nachActivation ||
              specialAccessHeaderMap.nachDeactivation) && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="approval"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip title="Approval" disableHoverListener={!expanded}>
                    <ApprovalIcon fontSize="medium" sx={{ color: "white" }} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Approval"
                />
              </ListItemButton>
            )}

            {specialAccessHeaderMap.nachExclude && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="nachExclude"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip title="Exclude" disableHoverListener={!expanded}>
                    <ApprovalIcon fontSize="medium" sx={{ color: "white" }} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Exclude"
                />
              </ListItemButton>
            )}
            {specialAccessHeaderMap.nachRetrieval && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="nachRetrieval"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip title="Retrieval" disableHoverListener={!expanded}>
                    <GetAppIcon fontSize="medium" sx={{ color: "white" }} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Retrieval"
                />
              </ListItemButton>
            )}
            {specialAccessHeaderMap.nachPosting && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="posting"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip title="Posting" disableHoverListener={!expanded}>
                    <VerifiedUserIcon
                      fontSize="medium"
                      sx={{ color: "white" }}
                    />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Posting"
                />
              </ListItemButton>
            )}
          </List>
        </Collapse>

        {/* File Receipt */}
        {specialAccessHeaderMap.fileReceipt && (
          <ListItemButton id="fileReceipt" onClick={handlerFileReceiptSubMenu}>
            <ListItemIcon>
              <Tooltip title="Receipt" disableHoverListener={!expanded}>
                <ReceiptLongTwoTone fontSize="medium" sx={{ color: "white" }} />
              </Tooltip>
            </ListItemIcon>
            <ListItemText primary="Receipt" sx={{ display: "block" }} />
            {openFileReceiptSubMenu ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        )}
        <Collapse in={openFileReceiptSubMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {/* fileReceiptCreate */}
            {specialAccessHeaderMap.fileReceiptCreate && (
              <ListItemButton id="fileReceiptCreate" onClick={menuClickHandler}>
                <ListItemIcon>
                  <Tooltip
                    title="Receipt Create"
                    disableHoverListener={!expanded}
                  >
                    <NoteAddIcon fontSize="medium" sx={{ color: "white" }} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary="Receipt Create"
                  sx={{ display: "block" }}
                />
              </ListItemButton>
            )}
            {/* fileReceiptView */}
            {(specialAccessHeaderMap.fileReceiptView ||
              specialAccessHeaderMap.fileReceiptModify) && (
              <ListItemButton id="fileReceiptView" onClick={menuClickHandler}>
                <ListItemIcon>
                  <Tooltip
                    title="Receipt View / Modify"
                    disableHoverListener={!expanded}
                  >
                    <Preview fontSize="medium" sx={{ color: "white" }} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary="Receipt View / Modify"
                  sx={{ display: "block" }}
                />
              </ListItemButton>
            )}
          </List>
        </Collapse>

        {/* Journal Voucher */}
        {specialAccessHeaderMap.journalVoucher && (
          <ListItemButton id="jv" onClick={handlerJVSubMenu}>
            <ListItemIcon>
              <Tooltip title="Journal Voucher" disableHoverListener={!expanded}>
                <AccountBalanceIcon fontSize="medium" sx={{ color: "white" }} />
              </Tooltip>
            </ListItemIcon>
            <ListItemText primary="Journal Voucher" sx={{ display: "block" }} />
            {openJVSubMenu ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        )}
        <Collapse in={openJVSubMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {/* Journal Voucher Create */}
            {specialAccessHeaderMap.journalVoucherCreate && (
              <ListItemButton id="jvCreate" onClick={menuClickHandler}>
                <ListItemIcon>
                  <Tooltip
                    title="Journal Voucher Create"
                    disableHoverListener={!expanded}
                  >
                    <AccountBalanceIcon
                      fontSize="medium"
                      sx={{ color: "white" }}
                    />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary="Journal Voucher Create"
                  sx={{ display: "block" }}
                />
              </ListItemButton>
            )}
            {(specialAccessHeaderMap.journalVoucherApprove ||
              specialAccessHeaderMap.journalVoucherDelete ||
              specialAccessHeaderMap.journalVoucherModify ||
              specialAccessHeaderMap.journalVoucherView) && (
              <ListItemButton id="jvDetail" onClick={menuClickHandler}>
                <ListItemIcon>
                  <Tooltip
                    title="Journal Voucher Detail"
                    disableHoverListener={!expanded}
                  >
                    <AccountBalanceIcon
                      fontSize="medium"
                      sx={{ color: "white" }}
                    />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary="Journal Voucher Detail"
                  sx={{ display: "block" }}
                />
              </ListItemButton>
            )}
          </List>
        </Collapse>

        {/* File Payment */}
        {specialAccessHeaderMap.filePayment && (
          <ListItemButton id="fee" onClick={handleFilePaymentSubMenu}>
            <ListItemIcon>
              <Tooltip title="Refund" disableHoverListener={!expanded}>
                <PaidIcon fontSize="medium" sx={{ color: "white" }} />
              </Tooltip>
            </ListItemIcon>
            <ListItemText
              id="menu-lable"
              primary="Refund"
              sx={{ display: "block" }}
            />
            {openFilePaymentSubMenu ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        )}
        <Collapse in={openFilePaymentSubMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {specialAccessHeaderMap.filePaymentCreate && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="filePaymentCreate"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip
                    title="Refund Create"
                    disableHoverListener={!expanded}
                  >
                    <NoteAddIcon fontSize="medium" sx={{ color: "white" }} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Refund Create"
                />
              </ListItemButton>
            )}
            {(specialAccessHeaderMap.filePaymentApproval ||
              specialAccessHeaderMap.filePaymentDelete ||
              specialAccessHeaderMap.filePaymentModify ||
              specialAccessHeaderMap.filePaymentView) && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="filePayment"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip
                    title="Refund View / Modify"
                    disableHoverListener={!expanded}
                  >
                    <ApprovalIcon fontSize="medium" sx={{ color: "white" }} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Refund View / Modify"
                />
              </ListItemButton>
            )}
          </List>
        </Collapse>

        {/* Return Process */}
        {specialAccessHeaderMap.return && (
          <ListItemButton
            id="returnProcess"
            onClick={handlerReturnProcessSubMenu}
          >
            <ListItemIcon>
              <Tooltip title="Return Process" disableHoverListener={!expanded}>
                <AssignmentReturn fontSize="medium" sx={{ color: "white" }} />
              </Tooltip>
            </ListItemIcon>
            <ListItemText primary="Return Process" sx={{ display: "block" }} />
            {openReturnProcessSubMenu ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        )}
        <Collapse in={openReturnProcessSubMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {/* Cheque Return Process */}
            {specialAccessHeaderMap.chequeReturn && (
              <ListItemButton id="chequeReturn" onClick={menuClickHandler}>
                <ListItemIcon>
                  <Tooltip
                    title="Cheque Return"
                    disableHoverListener={!expanded}
                  >
                    <AssignmentReturn
                      fontSize="medium"
                      sx={{ color: "white" }}
                    />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary="Cheque Return"
                  sx={{ display: "block" }}
                />
              </ListItemButton>
            )}
            {/* Mandate Return Process */}
            {specialAccessHeaderMap.mandateReturn && (
              <ListItemButton id="mandateReturn" onClick={menuClickHandler}>
                <ListItemIcon>
                  <Tooltip
                    title="Mandate Return"
                    disableHoverListener={!expanded}
                  >
                    <Undo fontSize="medium" sx={{ color: "white" }} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary="Mandate Return"
                  sx={{ display: "block" }}
                />
              </ListItemButton>
            )}
            {/* Bulk Cheque and Mandate Return Process */}
            {specialAccessHeaderMap.bulkReturn && (
              <ListItemButton
                id="bulkChequeAndMandateReturn"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip
                    title="Bulk Return Process"
                    disableHoverListener={!expanded}
                  >
                    <UploadFileIcon fontSize="medium" sx={{ color: "white" }} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary="Bulk Return Process"
                  sx={{ display: "block" }}
                />
              </ListItemButton>
            )}
          </List>
        </Collapse>

        {/* Security Post Dated Cheque Collection */}
        {specialAccessHeaderMap.security && (
          <ListItemButton id="securityChequeMenu" onClick={handlerPDCSubMenu}>
            <ListItemIcon>
              <Tooltip
                title="Security Post Dated Cheque"
                disableHoverListener={!expanded}
              >
                <LibraryBooks fontSize="medium" sx={{ color: "white" }} />
              </Tooltip>
            </ListItemIcon>
            <ListItemText primary="Security PDC" sx={{ display: "block" }} />
            {openPDCSubMenu ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        )}
        <Collapse in={openPDCSubMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {/* Security Post Dated Cheque Create */}
            {specialAccessHeaderMap.securityChequeCreate && (
              <ListItemButton
                id="securityChequeCreate"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip
                    title="Security Post Dated Cheque Create"
                    disableHoverListener={!expanded}
                  >
                    <NoteAddIcon fontSize="medium" sx={{ color: "white" }} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary="Security PDC Create"
                  sx={{ display: "block" }}
                />
              </ListItemButton>
            )}
            {/* Security Post Dated Cheque View & Modify */}
            {specialAccessHeaderMap.securityChequeModify && (
              <ListItemButton id="securityCheque" onClick={menuClickHandler}>
                <ListItemIcon>
                  <Tooltip
                    title="Security Post Dated Cheque View / Modify"
                    disableHoverListener={!expanded}
                  >
                    <SaveAs fontSize="medium" sx={{ color: "white" }} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary="Security PDC View / Modify"
                  sx={{ display: "block" }}
                />
              </ListItemButton>
            )}
          </List>
        </Collapse>

        {/* Master screens list */}
        {specialAccessHeaderMap.master && (
          <ListItemButton id="masterscreens" onClick={handleMasterSubMenu}>
            <ListItemIcon>
              <Tooltip title="Master Screens" disableHoverListener={!expanded}>
                <CurrencyRupeeTwoTone
                  fontSize="medium"
                  sx={{ color: "white" }}
                />
              </Tooltip>
            </ListItemIcon>
            <ListItemText
              id="menu-lable"
              primary="Master Screens"
              sx={{ display: "block" }}
            />
            {openMasterSubMenu ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        )}
        <Collapse in={openMasterSubMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {specialAccessHeaderMap.cashHandlingCharge && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="cashHandlingCharge"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  {/* <img id='layout-menu-image' src={Insurance} /> */}
                  <Tooltip
                    title="Cash Handling Charges"
                    disableHoverListener={!expanded}
                  >
                    <AccountTreeTwoTone
                      fontSize="medium"
                      sx={{ color: "white" }}
                    />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Cash Handling Charges"
                />
              </ListItemButton>
            )}
            {specialAccessHeaderMap.prePaymentHandling && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="prePaymentHandling"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  {/* <img id='layout-menu-image' src={Insurance} /> */}
                  <Tooltip
                    title="Pre Payment Handling"
                    disableHoverListener={!expanded}
                  >
                    <AccountTreeTwoTone
                      fontSize="medium"
                      sx={{ color: "white" }}
                    />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Pre Payment Handling"
                />
              </ListItemButton>
            )}
            {specialAccessHeaderMap.specialFunctionAccess && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="specialFunctionAccess"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  {/* <img id='layout-menu-image' src={Insurance} /> */}
                  <Tooltip
                    title="Special Function Access"
                    disableHoverListener={!expanded}
                  >
                    <AccountTreeTwoTone
                      fontSize="medium"
                      sx={{ color: "white" }}
                    />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Special Function Access"
                />
              </ListItemButton>
            )}
            {specialAccessHeaderMap.listOfValue && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="lov"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  {/* <img id='layout-menu-image' src={Insurance} /> */}
                  <Tooltip
                    title="List Of Values"
                    disableHoverListener={!expanded}
                  >
                    <AccountTreeTwoTone
                      fontSize="medium"
                      sx={{ color: "white" }}
                    />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="List Of Values"
                />
              </ListItemButton>
            )}
            {specialAccessHeaderMap.losMaster && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="losMaster"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  {/* <img id='layout-menu-image' src={Insurance} /> */}
                  <Tooltip title="LOS Master" disableHoverListener={!expanded}>
                    <AccountTreeTwoTone
                      fontSize="medium"
                      sx={{ color: "white" }}
                    />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="LOS Master"
                />
              </ListItemButton>
            )}
            {/* {specialAccessHeaderMap.feeDefinition && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="feeDefinition"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip title="LOS Master" disableHoverListener={!expanded}>
                    <AccountTreeTwoTone
                      fontSize="medium"
                      sx={{ color: "white" }}
                    />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Fee Definition"
                />
              </ListItemButton>
            )}
            {specialAccessHeaderMap.feeRateDefinition && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="feeRateDefinition"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip
                    title="Fee Rate Definition"
                    disableHoverListener={!expanded}
                  >
                    <AccountTreeTwoTone
                      fontSize="medium"
                      sx={{ color: "white" }}
                    />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Fee Rate Definition"
                />
              </ListItemButton>
            )} */}
            {/* {specialAccessHeaderMap.listOfValue && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="companyMaster"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip
                    title="Company Master"
                    disableHoverListener={!expanded}
                  >
                    <AccountTreeTwoTone
                      fontSize="medium"
                      sx={{ color: "white" }}
                    />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Company Master"
                />
              </ListItemButton>
            )} */}
          </List>
        </Collapse>

        {/* Reports */}
        {specialAccessHeaderMap.reports && (
          <ListItemButton id="reports" onClick={handlerReportsSubMenu}>
            <ListItemIcon>
              <Tooltip title="Reports" disableHoverListener={!expanded}>
                <Summarize fontSize="medium" sx={{ color: "white" }} />
              </Tooltip>
            </ListItemIcon>
            <ListItemText primary="Reports" sx={{ display: "block" }} />
            {openReportsSubMenu ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        )}
        <Collapse in={openReportsSubMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {/* Amort Calculation */}
            {specialAccessHeaderMap.amortCalculation && (
              <ListItemButton id="amortCalculation" onClick={menuClickHandler}>
                <ListItemIcon>
                  <Tooltip
                    title="Amort Calculation"
                    disableHoverListener={!expanded}
                  >
                    <FunctionsIcon fontSize="medium" sx={{ color: "white" }} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary="Amort Calculation"
                  sx={{ display: "block" }}
                />
              </ListItemButton>
            )}

            {/* Report Process */}
            {specialAccessHeaderMap.reportProcess && (
              <ListItemButton id="reportProcess" onClick={menuClickHandler}>
                <ListItemIcon>
                  <Tooltip
                    title="Report Process"
                    disableHoverListener={!expanded}
                  >
                    <Summarize fontSize="medium" sx={{ color: "white" }} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary="Report Process"
                  sx={{ display: "block" }}
                />
              </ListItemButton>
            )}

            {/* Settlement Figure Report */}
            {specialAccessHeaderMap.settlementFigureReport && (
              <ListItemButton
                id="settlementFigureReport"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip
                    title="Settlement Figure Report"
                    disableHoverListener={!expanded}
                  >
                    <Summarize fontSize="medium" sx={{ color: "white" }} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary="Settlement Figure Report"
                  sx={{ display: "block" }}
                />
              </ListItemButton>
            )}

            {/* Repayment Structure */}
            {specialAccessHeaderMap.repaymentStructure && (
              <ListItemButton
                id="repaymentStructure"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip
                    title="Repayment Structure"
                    disableHoverListener={!expanded}
                  >
                    <Summarize fontSize="medium" sx={{ color: "white" }} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary="Repayment Structure"
                  sx={{ display: "block" }}
                />
              </ListItemButton>
            )}
          </List>
        </Collapse>
        {/* Loan Closure */}
        {specialAccessHeaderMap.loanClosure && (
          <ListItemButton id="loanClosure" onClick={menuClickHandler}>
            <ListItemIcon>
              <Tooltip title="Loan Closure" disableHoverListener={!expanded}>
                <EngineeringTwoTone fontSize="medium" sx={{ color: "white" }} />
              </Tooltip>
            </ListItemIcon>
            <ListItemText primary="Loan Closure" sx={{ display: "block" }} />
          </ListItemButton>
        )}
        {/* Re-Schedulement */}
        {specialAccessHeaderMap.reSchedulement && (
          <ListItemButton id="reSchedulement" onClick={menuClickHandler}>
            <ListItemIcon>
              <Tooltip title="Re-Schedulement" disableHoverListener={!expanded}>
                <EventRepeatTwoTone fontSize="medium" sx={{ color: "white" }} />
              </Tooltip>
            </ListItemIcon>
            <ListItemText primary="Re-Schedulement" sx={{ display: "block" }} />
          </ListItemButton>
        )}

        {/* cov */}
        {specialAccessHeaderMap.customerOneView && (
          <ListItemButton id="cov" onClick={menuClickHandler}>
            <ListItemIcon>
              <Tooltip
                title="Customer One View(COV)"
                disableHoverListener={!expanded}
              >
                <EngineeringTwoTone fontSize="medium" sx={{ color: "white" }} />
              </Tooltip>
            </ListItemIcon>
            <ListItemText
              primary="Customer One View(COV)"
              sx={{ display: "block" }}
            />
          </ListItemButton>
        )}
        {specialAccessHeaderMap.letterGeneration && (
          <ListItemButton
            id="letterGenerate"
            onClick={handleLetterGenerationSubMenu}
          >
            <ListItemIcon>
              <Tooltip
                title="Letter Generation"
                disableHoverListener={!expanded}
              >
                <MarkEmailReadTwoTone
                  fontSize="medium"
                  sx={{ color: "white" }}
                />
              </Tooltip>
            </ListItemIcon>
            <ListItemText
              id="menu-lable"
              primary="Letter Generation"
              sx={{ display: "block" }}
            />
            {openLetterGenerationSubMenu ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        )}
        <Collapse in={openLetterGenerationSubMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {specialAccessHeaderMap.letterGenerationCreate && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="letterGeneration"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  {/* <img id='layout-menu-image' src={Insurance} /> */}
                  <Tooltip
                    title="Create / Modify"
                    disableHoverListener={!expanded}
                  >
                    <NoteAddTwoTone fontSize="medium" sx={{ color: "white" }} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Create / Modify"
                />
              </ListItemButton>
            )}
            {specialAccessHeaderMap.letterGenerationTrigger && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="letterGenerationTrigger"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip
                    title="View / Trigger"
                    disableHoverListener={!expanded}
                  >
                    <VisibilityTwoTone
                      fontSize="medium"
                      sx={{ color: "white" }}
                    />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="View / Trigger"
                />
              </ListItemButton>
            )}
          </List>
        </Collapse>
        {specialAccessHeaderMap.losData && (
          <ListItemButton id="" onClick={handlerLOSDataSubMenu}>
            <ListItemIcon>
              <Tooltip title="LOS Data" disableHoverListener={!expanded}>
                <DataThresholdingTwoTone
                  fontSize="medium"
                  sx={{ color: "white" }}
                />
              </Tooltip>
            </ListItemIcon>
            <ListItemText
              id="menu-lable"
              primary="LOS Data"
              sx={{ display: "block" }}
            />
            {openLOSDataSubMenu ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        )}
        <Collapse in={openLOSDataSubMenu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {specialAccessHeaderMap.leadInformation && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="leadInformation"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip
                    title="Lead Information"
                    disableHoverListener={!expanded}
                  >
                    <PolicyTwoTone fontSize="medium" sx={{ color: "white" }} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Lead Information"
                />
              </ListItemButton>
            )}

            {specialAccessHeaderMap.customerInformation && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="customerInformation"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip
                    title="Customer Information"
                    disableHoverListener={!expanded}
                  >
                    <SupportAgentTwoTone
                      fontSize="medium"
                      sx={{ color: "white" }}
                    />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Customer Information"
                />
              </ListItemButton>
            )}

            {specialAccessHeaderMap.applicantDetails && (
              <ListItemButton
                sx={{ pl: 4 }}
                id="applicantDetails"
                onClick={menuClickHandler}
              >
                <ListItemIcon>
                  <Tooltip
                    title="Applicant Details"
                    disableHoverListener={!expanded}
                  >
                    <DetailsTwoTone fontSize="medium" sx={{ color: "white" }} />
                  </Tooltip>
                </ListItemIcon>
                <ListItemText
                  id="menu-lable"
                  sx={{ display: "block" }}
                  primary="Applicant Details"
                />
              </ListItemButton>
            )}
          </List>
        </Collapse>
      </List>
      <div id="drawer-closer" onClick={handleDrawerClose}></div>
    </Box>
  );

  const desktopHeader = (
    <>
      <Stack direction="row" sx={{ width: "calc(100% - 600px)" }}>
        <img height="36px" src={Logo} alt="No Logo"></img>
      </Stack>

      <Stack direction="row" sx={{ width: "100%", justifyContent: "flex-end" }}>
        <Stack direction="column" sx={{ paddingRight: "8px" }}>
          <Typography sx={{ textAlign: "right" }}>{userName}</Typography>
          {!branchDetails.areaName && <Skeleton sx={{ width: "280px" }} />}
          {branchDetails.areaName && (
            <Chip
              label={`Area : ${branchDetails.areaName}, Zone : ${
                branchDetails.zoneName
              }${
                branchDetails.branchName !== ""
                  ? `, Branch : ${branchDetails.branchName}`
                  : ""
              }  `}
              component="div"
              sx={{ color: "white" }}
            />
          )}
        </Stack>
        <Divider
          sx={{
            borderWidth: "2px",
            backgroundColor: "#fff",
            height: "50px",
            marginTop: "5px",
          }}
          orientation="vertical"
          flexItem
        />
        {/* <IconButton color="inherit">
            <NotificationsIcon />
        </IconButton> */}
        <Stack direction="row" sx={{ alignItems: "center" }}>
          {/* <Tooltip title="Change Password">
            <IconButton>
              <PublishedWithChangesTwoTone
                sx={{ color: "white" }}
                fontSize="large"
              />
            </IconButton>
          </Tooltip> */}

          <ShortcutDialog />

          <Tooltip title="Logout">
            <IconButton onClick={handleLogout}>
              <LogoutTwoTone sx={{ color: "white" }} fontSize="large" />
            </IconButton>
          </Tooltip>
        </Stack>
      </Stack>
    </>
  );

  const mobileHeader = (
    <>
      <Stack direction="row" sx={{ width: "calc(100% - 600px)" }}>
        <img
          id="logoimage"
          src={SFLogoSmall}
          width={50}
          height={50}
          alt="No Logo"
        ></img>
      </Stack>
      <Stack direction="row" sx={{ width: "100%", justifyContent: "flex-end" }}>
        <Tooltip title="Account settings">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <Avatar sx={{ width: 32, height: 32 }}>
              <PersonIcon sx={{ color: "#004a92" }} />
            </Avatar>
          </IconButton>
        </Tooltip>
      </Stack>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem>
          <Stack direction="column" sx={{ paddingRight: "8px" }}>
            <Typography sx={{ marginTop: "8px", textAlign: "center" }}>
              <strong>{userName}</strong>
            </Typography>
            {/* Large Devices */}
            {useMediaQuery("(min-width:750px)") && (
              <Chip
                label={`Area : ${branchDetails.areaName}, Zone : ${
                  branchDetails.zoneName
                }${
                  branchDetails.branchName !== ""
                    ? `, Branch : ${branchDetails.branchName}`
                    : ""
                }  `}
                component="div"
                sx={{ color: "white", bgcolor: "#004a92" }}
              />
            )}
            {/* Small Devices */}
            {useMediaQuery("(max-width:750px)") && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Chip
                    label={`Area : ${branchDetails.areaName}, Zone : ${branchDetails.zoneName}`}
                    component="div"
                    sx={{ color: "white", bgcolor: "#004a92" }}
                  />
                </Box>
                <Box>
                  {branchDetails.branchName !== "" ? (
                    <Chip
                      label={`${
                        branchDetails.branchName !== ""
                          ? `Branch : ${branchDetails.branchName}`
                          : ""
                      }  `}
                      component="div"
                      sx={{ color: "white", bgcolor: "#004a92" }}
                    />
                  ) : null}
                </Box>
              </Box>
            )}
          </Stack>
          <Divider
            sx={{
              borderWidth: "2px",
              backgroundColor: "#fff",
              height: "50px",
              marginTop: "5px",
            }}
            orientation="vertical"
            flexItem
          />
          {/* <IconButton color="inherit">
              <NotificationsIcon />
          </IconButton> */}
        </MenuItem>
        <Divider />
        {/* <MenuItem>
          <ListItemButton>
            <ListItemIcon>
              <Tooltip title="Change Password" disableHoverListener={!expanded}>
                <PublishedWithChangesTwoTone
                  fontSize="large"
                  sx={{ color: "black" }}
                />
              </Tooltip>
            </ListItemIcon>
            <ListItemText id="menu-lable" primary="Change Password" />
          </ListItemButton>
        </MenuItem> */}
        <MenuItem>
          <ListItemButton onClick={handleLogout}>
            <ListItemIcon>
              <Tooltip title="Logout" disableHoverListener={!expanded}>
                <LogoutTwoTone fontSize="large" sx={{ color: "black" }} />
              </Tooltip>
            </ListItemIcon>
            <ListItemText id="menu-lable" primary="Logout" />
          </ListItemButton>
        </MenuItem>
      </Menu>
    </>
  );

  return (
    <Box sx={{ display: "flex" }}>
      {branches && branches.length > 0 && (
        <div
          className="anchor"
          onClick={handleDrawerOpen}
          height="100%"
          width="4px"
          backgroundColor="black"
        ></div>
      )}
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: "#004A92",
          height: "70px",
          justifyContent: "center",
        }}
      >
        <Toolbar>
          {branches && branches.length > 0 && (
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
              onClick={handleDrawerOpen}
            >
              <MenuIcon />
            </IconButton>
          )}
          {useMediaQuery("(min-width:1024px)") && desktopHeader}
          {useMediaQuery("(max-width:1023px)") && mobileHeader}
        </Toolbar>
      </AppBar>
      {branches && branches.length > 0 && (
        <div>
          <Drawer
            anchor="left"
            id="drawer-menu"
            open={expanded}
            onClose={handleDrawerClose}
            sx={{ zIndex: "1301 !important" }}
          >
            {list}
          </Drawer>
        </div>
      )}
      {/* Page Body */}
      <Box
        sx={{ width: "100%", marginTop: "70px", padding: "8px 0px 0px 8px" }}
      >
        {/* <Container
          sx={{ maxWidth:'unset !important' }}
        > */}
        {loading ? (
          <>
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={true}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </>
        ) : (
          <>
            {keyName === "pageNotFound" ? (
              <NoSpecialAccess />
            ) : (
              <Routes>
                <Route
                  path={`${search}/stlap/home/dashboard`}
                  element={<Dashboard />}
                />
                <Route
                  path={`${search}/stlap/home/parameter`}
                  element={<ParameterMaintenance />}
                />

                <Route
                  path={`${search}/stlap/home/chequeReturn`}
                  element={<ChequeReturn />}
                />
                <Route
                  path={`${search}/stlap/home/mandateReturn`}
                  element={<MandateReturn />}
                />
                <Route
                  path={`${search}/stlap/home/bulkReturn`}
                  element={<ChequeAndMandateBulkReturn />}
                />

                <Route
                  path={`${search}/stlap/home/disbursementCreatePortal`}
                  element={<DisbursementCreatePortal />}
                />
                <Route
                  path={`${search}/stlap/home/nachInward`}
                  element={<NachInward />}
                />
                <Route
                  path={`${search}/stlap/home/nachExclude`}
                  element={<NachExclude />}
                />
                <Route
                  path={`${search}/stlap/home/nachExtraction`}
                  element={<NachExtraction />}
                />
                <Route
                  path={`${search}/stlap/home/batchScheduling`}
                  element={<BatchScheduling />}
                />
                <Route
                  path={`${search}/stlap/home/disbursementCreate`}
                  element={
                    <DisbursementCreate
                      screenMode="CREATE"
                      screenTitle="Disbursement Request Create"
                    />
                  }
                />

                <Route
                  path={`${search}/stlap/home/disbursementModify`}
                  element={
                    <DisbursementModify
                      screenMode="MODIFY"
                      screenTitle="Disbursement Request Modify"
                    />
                  }
                />

                <Route
                  path={`${search}/stlap/home/disbursementCancel`}
                  element={
                    <DisbursementModify
                      screenMode="CANCEL"
                      screenTitle="Disbursement Request Cancel"
                    />
                  }
                />

                <Route
                  path={`${search}/stlap/home/disbursementApprove`}
                  element={
                    <DisbursementModify
                      screenMode="APPROVE"
                      screenTitle="Disbursement Request Approve"
                    />
                  }
                />

                <Route
                  path={`${search}/stlap/home/disbursementView`}
                  element={
                    <DisbursementView
                      screenMode="VIEW"
                      screenTitle="Disbursement Request View"
                    />
                  }
                />
                <Route
                  path={`${search}/stlap/home/loanClosure`}
                  element={<LoanClosure />}
                />
                <Route
                  path={`${search}/stlap/home/reschedulement`}
                  element={<ReSchedulementPage />}
                />
                {/* <Route
                  path={`${search}/stlap/home/companyMaster`}
                  element={<CompanyMaster />}
                /> */}

                <Route
                  path={`${search}/stlap/home/cov`}
                  element={<CovFilter />}
                />

                <Route
                  path={`${search}/stlap/home/CovLoanDetailsDashboard`}
                  element={<CovLoanDetailsDashboard />}
                />
                {/* <Route
                  path={`${search}/stlap/home/los/CovLosDashboard`}
                  element={<CovLosDashboard />}
                /> */}
                <Route
                  path={`${search}/stlap/home/disbursement/repaymentStructure`}
                  element={<RepaymentStructureFilter />}
                />

                <Route
                  path={`${search}/stlap/home/disbursementList`}
                  element={<DisbursementRequestList mode="REQUESTLIST" />}
                />

                <Route
                  path={`${search}/stlap/home/disbursementApprovalList`}
                  element={<DisbursementApprovalList />}
                />

                <Route
                  path={`${search}/stlap/home/nachMandate`}
                  element={<NachMandate />}
                />
                <Route
                  path={`${search}/stlap/home/nachRetrieval`}
                  element={<NachRetrieval />}
                />
                <Route
                  path={`${search}/stlap/home/amortCalculation`}
                  element={<AmortCalculation />}
                />
                <Route
                  path={`${search}/stlap/home/verification`}
                  element={<Verification />}
                />
                <Route
                  path={`${search}/stlap/home/approval`}
                  element={<NachActiveDeactive />}
                />

                <Route
                  path={`${search}/stlap/home/additionalAccrual`}
                  element={<AdditionalAccrual />}
                />
                <Route
                  path={`${search}/stlap/home/additionalWaiver`}
                  element={<AccrualWaiver />}
                />
                <Route
                  path={`${search}/stlap/home/posting`}
                  element={<Posting />}
                />
                <Route
                  path={`${search}/stlap/home/retrival`}
                  element={<Retrival />}
                />
                <Route
                  path={`${search}/stlap/home/repayment`}
                  element={<Repayment />}
                />
                <Route
                  path={`${search}/stlap/home/jvCreate`}
                  element={<JournalVoucher />}
                />
                {/* <Route
                  path={`${search}/stlap/home/jvView`}
                  element={<JournalVoucherView />}
                />
                <Route
                  path={`${search}/stlap/home/jvEdit`}
                  element={<JournalVoucherEdit />}
                />
                <Route
                  path={`${search}/stlap/home/jvDelete`}
                  element={<JournalVoucherDelete />}
                />
                <Route
                  path={`${search}/stlap/home/jvApprove`}
                  element={<JournalVoucherApprove />}
                /> */}
                <Route
                  path={`${search}/stlap/home/jvDetail`}
                  element={<JournalVoucherDetail />}
                />

                <Route
                  path={`${search}/stlap/home/filePaymentCreate`}
                  element={<FilePaymentIntegration />}
                />

                <Route
                  path={`${search}/stlap/home/CovScreenDashboard`}
                  element={<CovMainDashboard />}
                />
                <Route
                  path={`${search}/stlap/home/filePayment`}
                  element={<FilePaymentInt />}
                />
                <Route
                  path={`${search}/stlap/home/fileReceiptCreate`}
                  element={
                    <FileReceipt mode="CREATE" screenTitle={"Receipt Create"} />
                  }
                />
                <Route
                  path={`${search}/stlap/home/fileReceipt`}
                  element={<FileReceiptView />}
                />

                <Route
                  path={`${search}/stlap/home/securityChequeCreate`}
                  element={<SecurityCheque screenMode="CREATE" />}
                />
                <Route
                  path={`${search}/stlap/home/securityCheque`}
                  element={<SecurityCheque screenMode="VIEW" />}
                />

                <Route
                  path={`${search}/stlap/home/cashHandlingCharge`}
                  element={<CashHandlingCharge />}
                />
                {/* <Route
                  path={`${search}/stlap/home/nonPerformingLoan`}
                  element={<NonPerformingLoan />}
                /> */}
                <Route
                  path={`${search}/stlap/home/reportProcess`}
                  element={<ReportProcess />}
                />
                <Route
                  path={`${search}/stlap/home/settlementFigureReport`}
                  element={<SettlementFigureReport />}
                />
                <Route
                  path={`${search}/stlap/home/prePaymentHandling`}
                  element={<PrePaymentHandling />}
                />
                <Route
                  path={`${search}/stlap/home/specialFunctionAccess`}
                  element={<SpecialFunctionAccess />}
                />
                <Route
                  path={`${search}/stlap/home/losMaster`}
                  element={<LosMaster />}
                />
                <Route
                  path={`${search}/stlap/home/lov`}
                  element={<ListOfValue />}
                />
                {/* <Route
                  path={`${search}/stlap/home/feeDefinition`}
                  element={<FeeDefinition />}
                /> */}
                {/* <Route
                  path={`${search}/stlap/home/feeRateDefinition`}
                  element={<FeeRateDefinition />}
                /> */}
                <Route
                  path={`${search}/stlap/home/letterGeneration`}
                  element={<TextEditor />}
                />
                <Route
                  path={`${search}/stlap/home/letterGenerationTrigger`}
                  element={<TriggerView />}
                />
                <Route
                  path={`${search}/stlap/home/losData/leadInfoList`}
                  element={<LeadInfoList />}
                />
                <Route
                  path={`${search}/stlap/home/losData/leadInfoList/:leadId/:branchCode`}
                  element={<LeadInfo />}
                />
                <Route
                  path={`${search}/stlap/home/losData/customerInfoList`}
                  element={<CustomerInfoList />}
                />
                <Route
                  path={`${search}/stlap/home/losData/customerInfoList/:internalCustomerId`}
                  element={<CustomerInfo />}
                />

                <Route
                  path={`${search}/stlap/home/losData/applicantInfoList`}
                  element={<ApplicantList />}
                />
                <Route
                  path={`${search}/stlap/home/losData/applicantInfoList/:internalApplicationId`}
                  element={<ApplicantDetails />}
                />
                <Route path="*" exact element={<PageNotFound />} />
                {/* <Route path="*" exact={true} element={<Loginpage />} /> */}
              </Routes>
            )}
          </>
        )}

        {/* </Container> */}
      </Box>
    </Box>
  );
}
